/*
  Dtcs state
*/
export default {
  loading: false,
  eventList: [],
  eventDictList: [],
  codeList: [],
  codeDictList: [],
  timeList: {
    today: [],
    yesterday: [],
    thisWeek: [],
    lastWeek: []
  },
  amberTimeList: {
    today: [],
    yesterday: [],
    thisWeek: [],
    lastWeek: []
  },
  redTimeList: {
    today: [],
    yesterday: [],
    thisWeek: [],
    lastWeek: []
  }
}
